

export function serializeQuery(query) {
    return {
        ...query,
        page: query?.page ?? 1,
    }
}

export function parseQuery(query) {
    return {
        ...query,
        month: query.month ?? null,
    }
}
